(() => {

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

      var $parcel$global = globalThis;
    var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1sonw", function(module, exports) {

module.exports = (parcelRequire("6ggFO"))($parcel$resolve("9p11z")).then(()=>parcelRequire('hPR1f'));

});
parcelRegister("6ggFO", function(module, exports) {
"use strict";

var $93SdL = parcelRequire("93SdL");
module.exports = $93SdL(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});
parcelRegister("93SdL", function(module, exports) {
"use strict";
var $698e7401e5595953$var$cachedBundles = {};
var $698e7401e5595953$var$cachedPreloads = {};
var $698e7401e5595953$var$cachedPrefetches = {};
function $698e7401e5595953$var$getCache(type) {
    switch(type){
        case 'preload':
            return $698e7401e5595953$var$cachedPreloads;
        case 'prefetch':
            return $698e7401e5595953$var$cachedPrefetches;
        default:
            return $698e7401e5595953$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $698e7401e5595953$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



var $e0de52238377d83b$exports = {};
$parcel$extendImportMap({
    "9p11z": "transitions.328a9e55.js"
});


document.addEventListener("DOMContentLoaded", function() {
    // Sticky Header
    const header = document.querySelector('.site-header');
    const scrollThreshold = 1;
    function updateHeaderClass() {
        if (!header) return; // Guard clause for page editor
        if (window.scrollY > scrollThreshold) header.classList.add("scrolled");
        else header.classList.remove("scrolled");
    }
    // Check on page load
    updateHeaderClass();
    // Check on scroll
    document.addEventListener("scroll", updateHeaderClass);
    // Mobile Navigation - Offcanvas
    const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
    const mobileMenu = document.querySelector('.mobile-menu');
    const body = document.body;
    if (mobileMenuToggle && mobileMenu) {
        // Create overlay element
        const overlay = document.createElement('div');
        overlay.classList.add('mobile-menu-overlay');
        body.appendChild(overlay);
        // Open mobile menu
        function openMobileMenu() {
            mobileMenuToggle.setAttribute('aria-expanded', 'true');
            mobileMenu.setAttribute('aria-hidden', 'false');
            overlay.classList.add('active');
            body.style.overflow = 'hidden';
            const firstMenuItem = mobileMenu.querySelector('a');
            if (firstMenuItem) firstMenuItem.focus();
        }
        // Close mobile menu
        function closeMobileMenu() {
            mobileMenuToggle.setAttribute('aria-expanded', 'false');
            mobileMenu.setAttribute('aria-hidden', 'true');
            overlay.classList.remove('active');
            body.style.overflow = '';
            mobileMenuToggle.focus();
        }
        // Toggle mobile menu
        mobileMenuToggle.addEventListener('click', function() {
            const isExpanded = this.getAttribute('aria-expanded') === 'true';
            isExpanded ? closeMobileMenu() : openMobileMenu();
        });
        // Close on overlay click
        overlay.addEventListener('click', closeMobileMenu);
        // Close with Escape key
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' && mobileMenu.getAttribute('aria-hidden') === 'false') closeMobileMenu();
        });
        // Close on menu link click
        mobileMenu.querySelectorAll('a').forEach((link)=>{
            link.addEventListener('click', closeMobileMenu);
        });
        // Handle window resize
        window.addEventListener('resize', function() {
            if (window.innerWidth > 890) closeMobileMenu();
        });
    }
});


// Smooth scroll to element on page load if hash exists in URL
document.addEventListener('DOMContentLoaded', ()=>{
    const hash = window.location.hash;
    if (hash) {
        const targetId = hash.substring(1); // Remove '#' from the hash
        const targetElement = document.getElementById(targetId);
        if (targetElement) setTimeout(()=>{
            $224396efd13bdefb$var$scrollToTarget(targetElement);
            // Open the accordion if it's a collapsible section
            if (targetElement.classList.contains('accordion-collapse')) {
                targetElement.classList.add('show'); // Open the accordion
                const button = document.querySelector(`[data-bs-target="#${targetId}"]`);
                if (button) button.classList.remove('collapsed'); // Ensure the button state is correct
            }
        }, 0); // Delay to ensure DOM is ready
    }
});
// Smooth scroll to clicked anchor link
function $224396efd13bdefb$var$handleAnchorClick(e) {
    const targetUrl = this.getAttribute('href');
    console.log('Anchor clicked:', targetUrl);
    console.log('Current page:', window.location.href);
    if ($224396efd13bdefb$var$isSamePageAnchor(targetUrl)) {
        console.log('Same page detected, preventing default');
        e.preventDefault(); // Prevent default anchor behavior
        const targetId = targetUrl.substring(targetUrl.indexOf('#') + 1);
        console.log('Target ID:', targetId);
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
            console.log('Target element found, scrolling');
            $224396efd13bdefb$var$scrollToTarget(targetElement);
            // Open the accordion if it's a collapsible section
            if (targetElement.classList.contains('accordion-collapse')) {
                targetElement.classList.add('show'); // Open the accordion
                const button = document.querySelector(`[data-bs-target="#${targetId}"]`);
                if (button) button.classList.remove('collapsed'); // Ensure the button state is correct
            }
            // Close the menu if it's a navigation link
            if (this.classList.contains('nav-link') || this.closest('.navbar-nav')) $224396efd13bdefb$var$collapseMenu();
        } else console.log('Target element not found for ID:', targetId);
    } else console.log('Different page, allowing normal navigation');
}
// Add event listeners to existing anchor links
document.querySelectorAll('a[href*="#"]').forEach((anchor)=>{
    anchor.addEventListener('click', $224396efd13bdefb$var$handleAnchorClick);
});
// Also handle dynamically added menu items (for dropdowns that might be added after page load)
document.addEventListener('click', function(e) {
    if (e.target.matches('a[href*="#"]')) $224396efd13bdefb$var$handleAnchorClick.call(e.target, e);
});
// Function to scroll to target element smoothly
function $224396efd13bdefb$var$scrollToTarget(target) {
    target.scrollIntoView({
        behavior: 'smooth'
    });
}
// Function to check if the anchor is on the same page
function $224396efd13bdefb$var$isSamePageAnchor(anchorUrl) {
    // Get the current page URL without hash and query parameters
    const currentUrl = new URL(window.location.href);
    const currentPath = currentUrl.pathname.replace(/\/$/, ''); // Remove trailing slash
    // Get the target URL without hash and query parameters
    const targetUrl = new URL(anchorUrl, window.location.origin);
    const targetPath = targetUrl.pathname.replace(/\/$/, ''); // Remove trailing slash
    // Compare the paths
    return currentPath === targetPath;
}
// Function to collapse the mobile menu and close dropdowns
function $224396efd13bdefb$var$collapseMenu() {
    // Close mobile menu
    const body = document.body;
    const hamburger = document.querySelector('.hamburger');
    const mobileMenu = document.querySelector('.main-menu-mobile');
    const navbarToggler = document.querySelector('.navbar-toggler');
    if (body) body.classList.remove('menu-active');
    if (hamburger) hamburger.classList.remove('is-active');
    if (mobileMenu) mobileMenu.classList.remove('show');
    if (navbarToggler) {
        navbarToggler.classList.remove('collapse');
        navbarToggler.classList.remove('is-active');
        navbarToggler.classList.add('collapsed');
    }
    // Close Bootstrap dropdowns
    const dropdownMenus = document.querySelectorAll('.dropdown-menu.show');
    dropdownMenus.forEach((dropdown)=>{
        dropdown.classList.remove('show');
    });
    // Close Bootstrap offcanvas
    const offcanvas = document.querySelector('.offcanvas.show');
    if (offcanvas) {
        const offcanvasInstance = bootstrap.Offcanvas.getInstance(offcanvas);
        if (offcanvasInstance) offcanvasInstance.hide();
    }
}


document.addEventListener("DOMContentLoaded", ()=>{
    // Video Controls
    const videos = document.querySelectorAll("video");
    if (!videos.length) return;
    videos.forEach((video)=>{
        let videoStarted = false;
        // NOTE: appears unused, leaving as-is to avoid changing behavior elsewhere
        const videoControls = document.getElementById("video-controls");
        const playButton = video.parentNode.querySelector(".video-play");
        if (!playButton) return;
        // Wrapper + poster surface (reliable poster restore on iOS)
        const wrap = video.closest(".video-wrap") || video.parentNode;
        const posterUrl = video.getAttribute("poster");
        if (wrap && posterUrl) {
            wrap.style.setProperty("--video-poster", `url("${posterUrl}")`);
            wrap.classList.add("has-poster", "show-poster");
        }
        function showPosterSurface() {
            if (wrap && posterUrl) wrap.classList.add("show-poster");
        }
        function hidePosterSurface() {
            if (wrap && posterUrl) wrap.classList.remove("show-poster");
        }
        // State sync:
        // - Playing: show native controls, hide overlay, hide poster surface
        // - Paused mid-video: keep native controls ON (so scrubbing works), hide overlay
        // - At start (t=0) or ended: hide native controls, show overlay, show poster surface
        function syncUI() {
            const atStart = video.currentTime === 0 && (video.paused || video.ended);
            const atEnd = !!video.ended;
            if (!video.paused && !video.ended) {
                // Playing
                hidePosterSurface();
                video.controls = true;
                playButton.classList.add("d-none");
                video.classList.add("pointer");
                return;
            }
            // Paused or ended
            if (atEnd || atStart) {
                // Start/end state: show poster + overlay
                showPosterSurface();
                video.controls = false;
                playButton.classList.remove("d-none");
                video.classList.remove("pointer");
            } else {
                // Paused mid-video: keep controls so user can scrub; hide overlay to avoid blocking / double-play look (iOS)
                hidePosterSurface();
                video.controls = true;
                playButton.classList.add("d-none");
                video.classList.remove("pointer");
            }
        }
        function playVideo() {
            if (!videoStarted) {
                // set video start time to 0, allowing you to specify a poster frame timestamp
                video.currentTime = 0;
                videoStarted = true;
            }
            const playPromise = video.play();
            if (playPromise && typeof playPromise.catch === "function") playPromise.catch(()=>{
                // If playback fails (policy/error), keep UI usable
                video.controls = false;
                playButton.classList.remove("d-none");
                showPosterSurface();
            });
            syncUI();
        }
        function pauseVideo() {
            video.pause();
            syncUI();
        }
        // Overlay play button toggles play/pause
        playButton.addEventListener("click", (e)=>{
            e.preventDefault();
            e.stopPropagation();
            if (video.paused || video.ended) playVideo();
            else pauseVideo();
        });
        // Click-to-pause on the video (not fullscreen)
        video.addEventListener("click", ()=>{
            if (!video.paused && video.height < 700) pauseVideo();
        });
        // Keep UI in sync with real video state changes (native controls, keyboard, etc.)
        video.addEventListener("play", syncUI);
        video.addEventListener("pause", syncUI);
        // Ended: reset to poster reliably (esp. iOS)
        video.addEventListener("ended", ()=>{
            videoStarted = false;
            video.pause();
            video.currentTime = 0;
            // Return to poster + overlay state
            video.controls = false;
            playButton.classList.remove("d-none");
            showPosterSurface();
            // Helps poster rendering in some browsers
            video.load();
            syncUI();
        });
        // Standard fullscreen change (most browsers)
        video.addEventListener("fullscreenchange", ()=>{
            // If minimized from fullscreen and paused, resync UI
            if (video.height < 500 && video.paused) syncUI();
        });
        // iOS Safari fullscreen exit (fullscreenchange isn't reliable there)
        video.addEventListener("webkitendfullscreen", ()=>{
            // Just resync; keeps things consistent
            syncUI();
        });
        // Initialize UI state
        video.controls = false;
        syncUI();
    });
});


document.addEventListener('DOMContentLoaded', ()=>{
    const btn = document.querySelector('.blog-archive__load-more');
    if (!btn) return;
    const list = document.querySelector('.blog-archive__list');
    if (!list) return;
    btn.addEventListener('click', async ()=>{
        const paged = parseInt(btn.dataset.paged, 10);
        const perPage = parseInt(btn.dataset.perPage, 10);
        const maxPages = parseInt(btn.dataset.maxPages, 10);
        const nonce = btn.dataset.nonce;
        const context = btn.dataset.context || '{"type":"blog"}';
        if (![
            paged,
            perPage,
            maxPages
        ].every(Number.isInteger) || !nonce) {
            console.error('Load more is missing required configuration.');
            return;
        }
        btn.disabled = true;
        btn.textContent = "Loading\u2026";
        btn.setAttribute('aria-busy', 'true');
        const body = new URLSearchParams({
            action: 'blog_load_more',
            nonce: nonce,
            paged: paged,
            per_page: perPage,
            context: context
        });
        try {
            const res = await fetch(wfpAjax.ajaxUrl, {
                method: 'POST',
                body: body
            });
            const html = await res.text();
            if (!res.ok || html.trim() === '-1') throw new Error(`Load more request failed with status ${res.status}.`);
            if (!html.trim()) {
                btn.remove();
                return;
            }
            list.insertAdjacentHTML('beforeend', html);
            if (paged >= maxPages) btn.remove();
            else btn.dataset.paged = paged + 1;
        } catch (err) {
            console.error('Load more failed', err);
        } finally{
            if (btn.isConnected) {
                btn.disabled = false;
                btn.textContent = 'Load More';
                btn.removeAttribute('aria-busy');
            }
        }
    });
});



document.addEventListener('DOMContentLoaded', async ()=>{
    const body = document.body;
    const isHome = body && (body.classList.contains('home') || body.classList.contains('front-page'));
    if (isHome) return;
    const mod = await (parcelRequire("1sonw"));
    if (mod && typeof mod.initTransitions === 'function') mod.initTransitions();
});



})();
//# sourceMappingURL=main.js.map
